import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GetFaqsPaginated,
  GetFaqsByCategory,
  Faq,
  Category,
  GetFaqCategories,
} from '../models/faq.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private readonly API_URL = '/faqs';
  private apiService = inject(ApiService);


  getFaqs(page: number, size: number): Observable<GetFaqsPaginated> {
    return this.apiService.get<GetFaqsPaginated>(
      `${this.API_URL}?page=${page}&size=${size}`
    );
  }

  getFaqsByCategory(): Observable<GetFaqsByCategory> {
    return this.apiService.get<GetFaqsByCategory>(`${this.API_URL}/all`);
  }

  getFaqByUuid(uuid: string): Observable<Faq> {
    return this.apiService.get<Faq>(`${this.API_URL}/${uuid}`);
  }

  getFaqCategories(page: number, size: number): Observable<GetFaqCategories> {
    return this.apiService.get<GetFaqCategories>(
      `${this.API_URL}/categories?page=${page}&size=${size}`
    );
  }

  getFaqCategoryByUuid(uuid: string): Observable<Category> {
    return this.apiService.get<Category>(`${this.API_URL}/category/${uuid}`);
  }
}
